var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "TcNewAppointment" }, [
    _c("nav", { staticClass: "tabs mt-5" }, [
      _c("span", { staticClass: "tab active" }, [_vm._v("Solicitar cita")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "tab",
          on: {
            click: function($event) {
              return _vm.$root.setPage("my-appointments")
            }
          }
        },
        [_vm._v("Ver mis citas")]
      )
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "w-1/2 mx-auto mt-12" },
      _vm._l(_vm.getDelegations, function(d) {
        return _c(
          "li",
          {
            key: d.id,
            staticClass:
              "bg-white hover:bg-gray-300 cursor-pointer py-9 flex items-center justify-start p-5 mb-5 shadow-md rounded-xl text-3xl",
            on: {
              click: function($event) {
                return _vm.$root.newAppointment(d)
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "h-8 w-8",
                style: { color: d.color },
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }
              },
              [
                _c("circle", {
                  attrs: { cx: "12", cy: "12", r: "12", fill: "currentColor" }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "ml-4" }, [_vm._v(_vm._s(d.name))])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }